<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import pagination from "laravel-vue-pagination";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import {
  get_partner_login,
  set_partner,
  set_partner_details,
  set_user,
  set_user_detail,
  debounce,
  get_decimal,
  get_currency,
  date_ranges
} from "../../Helper/helper";
import moment from "moment";
import { reportService, deliveryZoneService } from "../../services";
/**
 * Report component
 */
export default {
  components: { Layout, PageHeader, pagination, DateRangePicker },
  data() {
    let startDate = this.$auth.partner_login ? this.moment().startOf('day').subtract(29, "days") : this.moment().startOf('day').subtract(6, "days");
    let endDate = this.moment().endOf("day").toDate();
    return {
      decimal:get_decimal(),
      currency: get_currency(),
      dateRange: { startDate, endDate },
      reports: [],
      reportsData: [],
      restaurant: [],
      restaurant_count: "",
      restaurants_id: "",
      paginations: {},
       countries: [],
      country: "0",
      states: [],
      state: "0",
      cities: [],
      city: "0",
      country_count: "",
      state_count: "",
      city_count: "",
      date_ranges: date_ranges,
      restaurant: [],
      restaurant_count: "",
      order_status: "",
      restaurants_id: "",
      limit: 2,
      perPage: 0,
      currentPage: 1,
      payment_method: "",
      filters: {
        start_date: this.$auth.partner_login ? this.moment().startOf('day').subtract(29, "days").format('YYYY-MM-DD') : this.moment().startOf('day').subtract(6, "days").format('YYYY-MM-DD'),
        end_date: this.moment().format('YYYY-MM-DD'),
      },
      sortBy: "created_at",
      moment: moment,
      loading: true,
      isDownloading: false,
      orderType: '',
      fields: [
        { key: "table_id", label: "#", sortable: false,thClass:"dis-event"},
        { key: "id", label: "Order ID", sortable: true},
        { key: "created_date", label: "Order Date", sortable: false,thClass:"dis-event"},
        { key: "user_name", label: "First Name", sortable: false,thClass:"dis-event"},
        { key: "customer_type", label: "Customer Type", sortable: true},
        { key: "email", label: "Customer Email", sortable: false,thClass:"dis-event"},
        { key: "driver_name", label: "Driver Name", sortable: false,thClass:"dis-event" },
        { key: "item_total", label: "Item Price", sortable: false,thClass:"dis-event" },
        { key: "total_vat", label: "Tax", sortable: false ,thClass:"dis-event"},
        { key: "total_refund_amount", label: "Refund Amount", sortable: false,thClass:"dis-event" },
        { key: "credit_amount", label: "Used Credits", sortable: false,thClass:"dis-event" },
        { key: "delivery_fee", label: "Delivery Charge", sortable: true},
        { key: "sub_total", label: "Sub Total", sortable: false,thClass:"dis-event" },
        { key: "collection_discount", label: "Collection Discount", sortable: false,thClass:"dis-event"},
        { key: "subscription_discount", label: "Subscription Discount", sortable: false,thClass:"dis-event"},
        { key: "coupon_discount", label: "Coupon Discount", sortable: false, requiresAdmin: true,thClass:"dis-event" },
        { key: "total_amount", label: "Total Amount", sortable: true,requiresAdmin: true},
        { key: "payment_method", label: "Payment Method", sortable: true },
        { key: "order_status", label: "Order Status", sortable: false,thClass:"dis-event"},        
      ],
      type: ''
    };
  },
  computed: {
    computedFields() {

      if(this.$auth.partner_login)
        return this.fields.filter(field => !field.requiresAdmin);
        
      // If the user IS an admin, return all fields.
      else 
        return this.fields;
    }
  },
  mounted() {
    // this.$data.fields[5].label = this.$auth.getRestaurantName() +' Name';
    // this.$data.fields[6].label = this.$auth.getDriverName() +' Name';
    // this.$data.fields[9].label = this.$auth.getDriverName() +' Earning';
    // this.getSalesReports();
    // this.saleExportCsv();
    // this.getRestaurants();
    // this.getVendorCountry();
    this.getSalesReports();
  },
  methods: {
    updateValues(date) {
      this.filters = {
        ...this.filters,
        start_date :  this.moment(date.startDate.toISOString()).format('YYYY-MM-DD'),
        end_date :  this.moment(date.endDate.toISOString()).format('YYYY-MM-DD'),
      }
      // this.saleExportCsv();
      this.getSalesReports();
    },
    dateFormat(classes, date) {
      this.filters = {
        ...this.filters,
        start_date: this.moment(date.startDate.toISOString()).format(
          "YYYY-MM-DD"
        ),
        end_date: this.moment(date.endDate.toISOString()).format("YYYY-MM-DD")
      };
    },
    downloadsCSV: function () {
      if(this.$auth.partner_login)
      {
        let reportsData =
          '\ufeff' +
          'Order ID,Order Date,First Name,Item Price,Coupon Discount,Payment Method,Order Status,Your Earning\n'
        this.reportsData.forEach((el) => {
          var line =
            el["id"] +
            "," +
            el["created_date"] +
            "," + 
            el["user_name"] +
            "," +
            el["sub_total"] +
            "," +
            el["coupon_discount"] +
            "," + 
            (el["payment_method"] == "Cash On Delivery"
              ? "COD"
              : "Online") + 
            "," + 
             (el["order_status"] == "Cancelled"
              ? "Cancelled"
              : "Delivered"
            ) +
            "," +
            el["earning"] +
            "\n"
          reportsData += line;
        });

        var blob = new Blob([reportsData], { type: "csv/plain" });
        var date = new Date().toLocaleString();
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "sales_" + date + ".csv";
        link.click();
      }
      else
      {

        let reportsData =
          '\ufeff' +
          'Order ID,Order Date,First Name,Customer Type,Customer Email,Driver Name,Item Price,Tax,Refund Amount,Used Credits,Delivery Charge,Sub Total,Collection Discount,Subscription Discount,Coupon Discount,Total Amount,Payment Method,Order Status\n'
        this.reportsData.forEach((el) => {
          var line =
            el["id"] +
            "," +
            el["created_date"] +
            "," + 
            el["user_name"] +
            "," +
            el["customer_type"] +
            "," +
            el["email"] +
            "," +
            (el["driver_name"] ? el["driver_name"] : "-") + 
            "," + 
            this.currency + ' ' + el['item_total'].toFixed(2) +
            "," +
            this.currency + ' ' + el['total_vat'].toFixed(2) +
            "," +
           this.currency + ' ' + el['total_refund_amount'].toFixed(2) +
            "," +
           this.currency + ' ' + (el['credit_amount'] ? el['credit_amount'] : "0.00")+
            "," +
           this.currency + ' ' + (el["delivery_fee"].toFixed(2)) +
            "," +
           this.currency + ' ' + (el["sub_total"].toFixed(2)) +
            "," +
           this.currency + ' ' + (el["collection_discount"] ? el["collection_discount"] : "0.00" ) +
            "," +
           this.currency + ' ' + (el["subscription_discount"] ? el["subscription_discount"] : "0.00" ) +
            "," +
           this.currency + ' ' + (el["coupon_discount"] ? el["coupon_discount"] : "0.00") +
            "," +
           this.currency + ' ' + (parseFloat(el["total_amount"]).toFixed(2) || '0.00') +
            "," +
            el["payment_method"] + 
            "," +
            el["order_status"] +
            "," +
            "\n"
          reportsData += line;
        });

        var blob = new Blob([reportsData], { type: "csv/plain" });
        var date = new Date().toLocaleString();
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "sales_" + date + ".csv";
        link.click();
      }
    },
    // getVendorCountry() {
    //   this.countries = [];
    //   this.states = [];
    //   this.cities = [];
    //   deliveryZoneService.getVendorCountry().then((response) => {
    //     this.countries = response.data.result;
    //     this.getVendorState();
    //   });
    // },
    //  getRestaurants(){
    //     this.restaurant = [];
    //     reportService.getAllRestaurantName({
    //         country_id: this.country,
    //         state_id: this.state,
    //         city_id: this.city
    //     }).then((response) => {
    //         this.restaurant = response.data.result;
    //         this.restaurant_id = this.restaurant[0].restaurant_id;
    //         this.searchData();
    //       });
    // },
    //  getVendorState() {
    //   this.city = '0';
    //   this.state = '0';
    //   this.states = [];
    //   this.cities = [];
    //   deliveryZoneService
    //     .getVendorState({
    //       country_id: this.country,
    //     })
    //     .then((response) => {
    //       this.states = response.data.result;
    //       this.getVendorCity();
    //     });
    // },
    // getVendorCity() {
    //   this.city = '0';
    //   this.cities = [];
    //   deliveryZoneService
    //     .getVendorCity({
    //       state_id:this.state ? this.state : '0',
    //       country_id: this.country
    //     })
    //     .then((response) => {
    //       this.cities = response.data.result;
    //       this.searchData();
    //       this.getRestaurants();
    //     });
    // },
    // citychange()
    // {
    //     this.searchData();
    //     this.getRestaurants();
    // },
    // getUser() {
    //   this.users = this.$auth.user;
    //   this.userdetail = this.$auth.setting;
    // },
    getSalesReports(page) {
      this.loading = true;
        reportService
          .getSalesReport({
            ...this.filters,
            sortBy: this.sortBy,
            orderBy: this.sortDesc ? "desc" : "asc",
            country: this.country,
            state: this.state,
            city: this.city,
            order_status:  this.order_status,
            restaurants_id: this.restaurants_id,
            page: page ? page : 1,
            type: this.type
          })
          .then((response) => {
            this.loading = false;
            this.paginations = response.data.result;
            this.reports = response.data.result.data;
          });
      
    },
    saleExportCsv() {
      if(this.$auth.partner_login)
      {
          this.isDownloading = true;
          reportService
          .exportToCsv({ 
            ...this.filters,
            payment_method:  this.payment_method,
            sortBy: this.sortBy,
            orderBy: this.sortDesc ? "desc" : "asc",
          })
          .then((response) => {
            this.isDownloading = false;
            this.reportsData = response.data.result;
            this.downloadsCSV();
          });
      }
      else
      {
          this.isDownloading = true;
          reportService
          .exportToCsv({ 
            ...this.filters,
            order_status: this.order_status,
            restaurants_id: this.restaurants_id,
            sortBy: this.sortBy,
            orderBy: this.sortDesc ? "desc" : "asc",
            type: this.type
          })
          .then((response) => {
            this.isDownloading = false;
            this.reportsData = response.data.result;
            this.downloadsCSV();
          });
      }
    },
    searchData() {
      this.getSalesReports();
      // this.saleExportCsv();
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getSalesReports();
      // this.saleExportCsv();
    },
  },
  filters: {
      date(val) {
        return val ? val.toLocaleString() : "";
      },
    },
};
</script>

<template>
  <Layout>
    <div>
       <div class="row">
          <div class="col-12">
              <div
              class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
              >
              <div class="page-title-left avatar-main-icon">
                  <div class="avatar-xs mr-3">
                  <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                      <i class="bx bx-purchase-tag"></i>
                  </span>
                  </div>
                  <div class="report-tag" v-if="!$auth.partner_login">
                    <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Sales Report') }}</h4>
                    <p><router-link :to="{ name: 'reports-list'}">{{ trans.get('__JSON__.Reports') }}</router-link> > {{ trans.get('__JSON__.Sales Report') }}</p>
                  </div>
                  <div class="report-tag" v-else>
                    <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Sales Report') }}</h4>
                    <p><router-link :to="{ name: 'vendor.reports.list'}">{{ trans.get('__JSON__.Reports') }}</router-link> > {{ trans.get('__JSON__.Sales Report') }}</p>
                  </div>
              </div>
              <div class="page-title-right">
                <button @click="saleExportCsv" class="btn btn-primary btn-rounded export-btn" v-if="isDownloading" disabled>{{ trans.get('__JSON__.Exporting...') }}</button>
                <button @click="saleExportCsv" class="btn btn-primary btn-rounded export-btn" v-else>{{ trans.get('__JSON__.Export To CSV') }}</button>
                <button @click="saleExportCsv" class="btn btn-primary btn-rounded m-export-btn"><i class="bx bx-archive-in"></i></button>
              </div>
              </div>
          </div>
      </div>

      <!-- end row -->
      <div class="row">
        <div class="col-12 list-table-main">
          <div class="card">
            <div class="card-body">
              <div class="row" v-if="$auth.partner_login">
                <div class="main-sales-report">
                  <div class="v-sales-report">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>{{ trans.get('__JSON__.Status') }} :</label>
                        <select class="custom-select" v-model="orderType" @change="searchData()">
                          <option value >{{ trans.get('__JSON__.All') }}</option>
                          <option value="Delivered" selected>{{ trans.get('__JSON__.Delivered') }}</option>
                          <option value="Cancelled">{{ trans.get('__JSON__.Cancelled') }}</option>
                          <option value="Cancelled">{{ trans.get('__JSON__.Cancelled') }}</option>
                        </select>
                      </div>
                    </div>
                    <!-- <div class="form-group">
                      <div class="date-range-list">
                        <label>{{ trans.get('__JSON__.Status') }} :</label>
                        <select class="custom-select" v-model="payment_method" @change="searchData()">
                          <option value selected>{{ trans.get('__JSON__.All') }}</option>
                          <option value="Cash On Delivery">{{ trans.get('__JSON__.COD') }}</option>
                          <option value="Online">{{ trans.get('__JSON__.Online') }}</option>
                        </select>
                      </div>
                    </div> -->
                  </div>
                  <div class="v-sales-report-date">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>{{trans.get('__JSON__.Date')}}:</label>
                        <date-range-picker
                          ref="picker"
                          :locale-data="{
                            firstDay: 1,
                            format: 'dd-mm-yyyy',
                          }"
                          :showDropdowns="true"
                          :showWeekNumbers="true"
                          opens="left"
                          v-model="dateRange"
                          @update="updateValues"
                        >
                          <template v-slot:input="picker" style="min-width: 350px">
                            {{ moment(picker.startDate.toISOString()).format('MMMM DD, YYYY') | date }} -
                            {{ moment(picker.endDate.toISOString()).format('MMMM DD, YYYY') | date }}
                          </template>
                        </date-range-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="!$auth.partner_login">
                <div class="sales-report col-sm-2 offset-sm-5">
                  <div class="form-group">
                    <div class="date-range-list">
                      <label>{{ trans.get('__JSON__.Customer Type') }} :</label>
                      <select class="custom-select" v-model="type" @change="searchData()">
                        <option value="" selected>{{ trans.get('__JSON__.All') }}</option>
                        <option value="1">{{ trans.get('__JSON__.Private') }}</option>
                        <option value="5">{{ trans.get('__JSON__.Business') }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="sales-report col-sm-2">
                  <div class="form-group">
                    <div class="date-range-list">
                      <label>{{ trans.get('__JSON__.Status') }} :</label>
                      <select class="custom-select" v-model="order_status" @change="searchData()">
                        <option value >{{ trans.get('__JSON__.All') }}</option>
                        <option value="7" selected>{{ trans.get('__JSON__.Delivered') }}</option>
                        <option value="14">{{ trans.get('__JSON__.Cancelled') }}</option>
                        <option value="16">{{ trans.get('__JSON__.Reserved') }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                 <div class="sales-report col-sm-3" v-if="!$auth.partner_login">
                  <div class="form-group">
                    <div class="date-range-list">
                      <label>{{ trans.get('__JSON__.Date') }} :</label>
                     <date-range-picker
                        ref="picker"
                        :locale-data="{
                          firstDay: 1,
                          format: 'dd-mm-yyyy',
                        }"
                        :showDropdowns="true"
                        :showWeekNumbers="true"
                        opens="left"
                        v-model="dateRange"
                        :ranges="date_ranges()"
                        @update="updateValues"
                      >
                        <template
                          v-slot:input="picker"
                          style="min-width: 350px"
                        >
                          {{ moment(picker.startDate.toISOString()).format('MMMM DD, YYYY') | date }} -
                          {{ moment(picker.endDate.toISOString()).format('MMMM DD, YYYY') | date }}
                        </template>
                      </date-range-picker>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="row" v-if="!$auth.partner_login">
                <div class="col-sm-4 offset-sm-8">
                  <div class="form-group">
                    <div class="date-range-list">
                      <label>{{trans.get('__JSON__.Date')}}:</label>
                      <date-range-picker
                        ref="picker"
                        :locale-data="{
                          firstDay: 1,
                          format: 'dd-mm-yyyy',
                        }"
                        :showDropdowns="true"
                        :showWeekNumbers="true"
                        opens="left"
                        v-model="dateRange"
                        @update="updateValues"
                      >
                        <template v-slot:input="picker" style="min-width: 350px">
                          {{ moment(picker.startDate.toISOString()).format('MMMM DD, YYYY') | date }} -
                          {{ moment(picker.endDate.toISOString()).format('MMMM DD, YYYY') | date }}
                        </template>
                      </date-range-picker>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="row table-responsive">
                <div class="col-12 table-main-list table table-centered table-nowrap sales-report-table">
                  <b-table
                    :items="reports"
                    :fields="computedFields"
                    :sort-by.sync="sortBy"
                    :no-local-sorting="true"
                    @sort-changed="sortingChanged"
                    :busy="loading"
                    show-empty
                  >
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>{{trans.get('__JSON__.Loading...')}}</strong>
                      </div>
                    </template>

                    <template v-slot:cell(table_id)="data">
                        <div>{{ data.index + 1 }}</div>
                    </template>


                    <template v-slot:cell(id)="data">
                      <div>{{data.item.id}}</div>
                    </template>

                    <template v-slot:cell(user_name)="data">
                        <span>{{ data.item.user_name }} {{ data.item.last_name }}</span>
                    </template>

                    <template v-slot:cell(driver_name)="data">
                        <span v-if="data.item.driver_name">{{ data.item.driver_name }}</span>
                        <span v-else>-</span>
                    </template>

                    <template v-slot:cell(sub_total)="data">
                      <span v-html="currency"></span>
                      {{data.item.sub_total.toFixed(2) || '0.00' }}
                    </template>

                     <template v-slot:cell(distance_km)="data">
                      <span v-if="data.item.distance_km">{{ data.item.distance_km }}</span>
                      <span v-else>0</span>
                    </template>



                     <template v-slot:cell(total_amount)="data">
                      <span v-html="currency"></span>
                      {{parseFloat(data.item.total_amount).toFixed(2) || '0.00' }}
                    </template>



                    <template v-slot:cell(collection_discount)="data">
                      <span v-html="currency"></span>
                      {{data.item.collection_discount.toFixed(2) }}
                    </template>

                    <template v-slot:cell(sub_discount_amount)="data">
                      <span v-html="currency"></span>
                      {{ data.item.sub_discount_amount ?  data.item.sub_discount_amount : "0.00" }}
                    </template>

                    <template v-slot:cell(coupon_discount)="data">
                      <span v-html="currency"></span>
                      {{data.item.coupon_discount ? data.item.coupon_discount : "0.00" }}
                    </template>


                    <template v-slot:cell(delivery_fee)="data">
                      <span v-html="currency"></span>
                      {{data.item.delivery_fee.toFixed(2) }}
                    </template>

                    <template v-slot:cell(item_total)="data">
                      <span v-html="currency"></span>
                      {{data.item.item_total.toFixed(2) }}
                    </template>

                     <template v-slot:cell(total_vat)="data">
                      <span v-html="currency"></span>
                      {{data.item.total_vat.toFixed(2) }}
                    </template>

                     <template v-slot:cell(total_refund_amount)="data">
                      <span v-html="currency"></span>
                      {{data.item.total_refund_amount.toFixed(2) }}
                    </template>

                    <template v-slot:cell(credit_amount)="data">
                      <span v-html="currency"></span>
                      {{data.item.credit_amount ? data.item.credit_amount : "0.00" }}
                    </template>

                    <template v-slot:cell(subscription_discount)="data">
                      <span v-html="currency"></span>
                      {{data.item.subscription_discount ? data.item.subscription_discount : "0.00" }}
                    </template>

                    <template #empty>
                      <p class="text-center">{{ trans.get('__JSON__.No Sales Report Found') }}</p>
                    </template>
                  </b-table>
                </div>
                <div class="row col-sm-5 offset-sm-7">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <pagination
                          :data="paginations"
                          :limit="limit"
                          @pagination-change-page="getSalesReports"
                        ></pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>


<style>
/* .sales-report-table .table thead th:nth-child(1),.sales-report-table .table thead th:nth-child(3),.sales-report-table .table thead th:nth-child(4),.sales-report-table .table thead th:nth-child(5),.sales-report-table .table thead th:nth-child(8),.sales-report-table .table thead th:nth-child(13){
    pointer-events: none;
} */
</style>